import React from 'react';
import { getCurrentColor, onUserImgError } from '../../../../helpers/Helpers';
import { ReactComponent as UserIcon } from '../../../../assets/svg/icons/user.svg';

import { createdAt } from '../../../../helpers/Dialogs';
import { useSelector } from 'react-redux';
import { Image } from 'antd';

const GroupChatItem = ({ chat, isCurrentChat, handleChatClick }) => {
    const account = useSelector((state) => state.account);

    const created_at = createdAt(chat.last_message);

    if (chat.admin_closed || chat.closed) {
        return (
            <div
                key={chat.id}
                className={isCurrentChat ? 'chat-nav-item is-active' : 'chat-nav-item'}
                onClick={(e) => handleChatClick(chat)}
            >
                <div className="chat-nav-info">
                    <h3 className="chat-nav-name d-inline-block">{`${chat.name}`}</h3>
                    <p className="chat-nav-text">Closed</p>
                </div>
                <div className="chat-nav-data">
                    <div className="chat-icons-group">
                        <p className={chat.new_messages > 0 ? 'chat-nav-msg-counter' : 'hidden-block'}>
                            {chat.new_messages}
                        </p>
                    </div>
                    <p className="chat-nav-date">{created_at}</p>
                </div>
            </div>
        );
    }

    const avatarsView = [];
    if (chat.members) {
        let index = 0;
        for (const member of chat.members) {
            if (index < 2 && member.role_key === 'univercity-student') {
                index += 1;
                avatarsView.push(
                    <div key={member.id} className="chat-random-img-block">
                        {member.avatar ? (
                            <Image
                                className="chat-name-img"
                                src={member.avatar.sizes['70x70'] || member.avatar.original}
                                onError={onUserImgError}
                                alt={member.name ? member.name.slice(0, 1).toUpperCase() : 'D'}
                            />
                        ) : (
                            <div
                                className={
                                    'chat-name-img' +
                                    (account.account_info && account.account_info.id == member.id
                                        ? ' personal-random-avatar'
                                        : '')
                                }
                                style={{ backgroundColor: getCurrentColor(member) }}
                            >
                                <span>{member.name ? member.name.slice(0, 1).toUpperCase() : 'D'}</span>
                            </div>
                        )}
                    </div>
                );
            }
        }
    }

    return (
        <div
            key={chat.id}
            className={isCurrentChat ? 'chat-nav-item is-active' : 'chat-nav-item'}
            onClick={(e) => handleChatClick(chat)}
        >
            <div className="chat-nav-item-info">
                <div className="chat-nav-item-left">{avatarsView}</div>
                <div className="chat-nav-item-right">
                    <h3 className="chat-nav-name">{`${chat.name}`}</h3>
                    <div className="chat-nav-info-bottom">
                        <span className="chat-nav-date">{created_at}</span>
                    </div>
                </div>
                <div className="chat-nav-data">
                    <div className="chat-icons-group">
                        {chat.new_messages > 0 && <span className="chat-list-counter">{chat.new_messages}</span>}
                    </div>
                    <div className="chat-nav-users-count-block">
                        <UserIcon />
                        <span className="chat-nav-users-count">{chat.members ? chat.members.length : ''}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GroupChatItem;
